<template>
<div class="chapter">
<div class="inner_page">
<p class="h1"><b>CONTENTS</b></p>
<p class="cont"><a href="#/preface">Preface</a></p>
<p class="cont"><a href="#/acknowledge">Acknowledgements</a></p>
<p class="cont"><a href="#/introduction">Introduction</a></p>
<p class="cont1"><a href="#/chapter01">Scarborough Family Massacre: Louisville, 1816</a></p>
<p class="cont"><span href="#/chapter02" title="Link target outside of Sample">The Arsenic Poisoning of Sarah Jane Gould: Louisville, 1858</span></p>
<p class="cont"><span href="#/chapter03" title="Link target outside of Sample">Almon Farnsworth’s Dreadful Death: Hermon, 1872</span></p>
<p class="cont"><span href="#/chapter04" title="Link target outside of Sample">The Unfortunate Murder of Maria Shay: Ogdensburg, 1872</span></p>
<p class="cont"><span href="#/chapter05" title="Link target outside of Sample">Van Dyke’s Dubious Conviction: Oswegatchie, 1877</span></p>
<p class="cont"><span href="#/chapter06" title="Link target outside of Sample">Frank Conroy, Wife Slasher: Ogdensburg, 1896</span></p>
<p class="cont"><span href="#/chapter07" title="Link target outside of Sample">The Plot to Poison Joseph Kipp: Clifton, 1904</span></p>
<p class="cont"><span href="#/chapter08" title="Link target outside of Sample">Jealous John Hall’s Violent End: Stockholm, 1905</span></p>
<p class="cont"><span href="#/chapter09" title="Link target outside of Sample">The Apple-Crowder Double Homicide: Black Lake, 1908</span></p>
<p class="cont"><span href="#/chapter10" title="Link target outside of Sample">Harry Hosmer’s Fatal Bike Ride: Fine, 1908</span></p>
<p class="cont"><span href="#/chapter11" title="Link target outside of Sample">Bloodbath at Buck Farm: Stockholm, 1917</span></p>
<p class="cont"><span href="#/chapter12" title="Link target outside of Sample">Who Killed Bessie White? Massena, 1917</span></p>
<p class="cont1"><span href="#/bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="cont"><span href="#/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?fc91502a